import { rootContainer } from './modules/Root';
import './sentryConfig';

export { default } from './publicApi';

const createContainer = () => {
  const containerId = 'chat-widget-root';
  let container = document.getElementById(containerId);

  if (!container) {
    container = document.createElement('div');
    container.id = containerId;
    document.body.appendChild(container);
  }

  container.style.position = 'fixed';
  container.style.bottom = '0';
  container.style.right = '0';
  container.style.zIndex = '9999';
  container.style.isolation = 'isolate';
  return container;
}

const initialize = () => {
  try {
    rootContainer(createContainer());
  } catch (error) {
    console.error('Failed to initialize Chat Widget:', error);
  }
};

if (typeof document !== 'undefined') {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initialize();
  } else {
    document.addEventListener('DOMContentLoaded', initialize);
  }
}
